import React, { memo, useMemo } from "react";
import { Clock, TrendingUp, Activity, AlertCircle, CheckCircle, LucideIcon } from "lucide-react";
import { Pill, PillVariant } from "./Pill";
import { EpicLane } from "../../types";

const laneConfigs: Record<string, { icon: LucideIcon }> = {
    Now: { icon: Clock },
    Next: { icon: TrendingUp },
    Later: { icon: Activity },
    Unassigned: { icon: AlertCircle },
    Done: { icon: CheckCircle },
};

interface LanePillProps {
    lane: string;
}

export const LanePill = memo(function LanePill({ lane }: LanePillProps) {
    // Map lane to PillVariant. Usually lowercase matches, but typed check is safer.
    const variant = useMemo(() => lane.toLowerCase() as PillVariant, [lane]);
    const config = useMemo(() => laneConfigs[lane] || laneConfigs.Unassigned, [lane]);
    const Icon = config.icon;

    return (
        <Pill variant={variant} className="flex items-center gap-1">
            <Icon className="w-3 h-3" />
            {lane}
        </Pill>
    );
});

export default LanePill;
